<script setup>
import AdvancedMonitoringManager from '@/views/apps/monitoring/list/AdvancedMonitoringManager.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'monitoring',
  },
})
</script>

<template>
  <section>
    <AdvancedMonitoringManager/>
  </section>
</template>
